import "./AMOLivraisons2.module.css";
import Header from "@/reusable_sections/Header";
import AmoLivraisonsServiceOverview from "./sections/AmoLivraisonsServiceOverview";
import KeyBenefits from "./sections/KeyBenefits";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
import Prestations from "./sections/Prestations";
import ImageGallery from "./sections/ImageGallery";
import ImagePlaceholder from "./sections/ImagePlaceholder";
import StrategicBenefits from "./sections/StrategicBenefits";
export default function AMOLivraisons2Page() {
  return <div>
      <Header />
      <AmoLivraisonsServiceOverview />
      <ImageGallery />
      <Prestations />
      <ImagePlaceholder />
      <KeyBenefits />
      <StrategicBenefits />
      <CallToAction />
      <Footer />
    </div>;
}